import { nortadaLogger } from '../components/common/logger';

const ussdSessionCloseReasonQueryToString = (reason: string): string => {
  const translations: Record<string, string> = {
    END: 'End',
    ABANDON: 'Abandon',
    TIMEOUT: 'Timeout',
    NOT_CLOSED_YET: 'Session in progress'
  };

  return translations[reason] ?? nortadaLogger.critical(`${reason} is unsupported Ussd session close reason query.`);
};

export default ussdSessionCloseReasonQueryToString;
